import {
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UnknownFieldExceptionClass;
function UnknownFieldException() {
  if (UnknownFieldExceptionClass === VOID) {
    class $ extends SerializationException() {
      static x1n(message) {
        var $this = this.c1o(message);
        captureStack($this, $this.w1n_1);
        return $this;
      }
      static d1o(index) {
        return this.x1n('An unknown field for index ' + index);
      }
    }
    initMetadataForClass($, 'UnknownFieldException');
    UnknownFieldExceptionClass = $;
  }
  return UnknownFieldExceptionClass;
}
function init_kotlinx_serialization_SerializationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.b1o_1);
}
var SerializationExceptionClass;
function SerializationException() {
  if (SerializationExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static e1o() {
        var $this = this.od();
        init_kotlinx_serialization_SerializationException($this);
        return $this;
      }
      static c1o(message) {
        var $this = this.n2(message);
        init_kotlinx_serialization_SerializationException($this);
        return $this;
      }
      static f1o(message, cause) {
        var $this = this.pd(message, cause);
        init_kotlinx_serialization_SerializationException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'SerializationException', $.e1o);
    SerializationExceptionClass = $;
  }
  return SerializationExceptionClass;
}
var MissingFieldExceptionClass;
function MissingFieldException() {
  if (MissingFieldExceptionClass === VOID) {
    class $ extends SerializationException() {
      static n1o(message, cause, missingFields, serialName) {
        var $this = this.f1o(message, cause);
        captureStack($this, $this.m1o_1);
        $this.k1o_1 = missingFields;
        $this.l1o_1 = serialName;
        return $this;
      }
      static o1o(missingFields, serialName) {
        var tmp0_message = missingFields.q2() === 1 ? "Field '" + missingFields.r2(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing";
        return this.n1o(tmp0_message, null, missingFields, serialName);
      }
      static p1o(missingField, serialName) {
        var tmp0_missingFields = listOf(missingField);
        var tmp1_message = "Field '" + missingField + "' is required for type with serial name '" + serialName + "', but it was missing";
        return this.n1o(tmp1_message, null, tmp0_missingFields, serialName);
      }
      q1o(newMessage) {
        return MissingFieldException().n1o(newMessage, this, this.k1o_1, this.l1o_1);
      }
    }
    initMetadataForClass($, 'MissingFieldException');
    MissingFieldExceptionClass = $;
  }
  return MissingFieldExceptionClass;
}
//region block: exports
export {
  MissingFieldException as MissingFieldException24tqif29emcmi,
  SerializationException as SerializationExceptioneqrdve3ts2n9,
  UnknownFieldException as UnknownFieldExceptiona60e3a6v1xqo,
};
//endregion

//# sourceMappingURL=SerializationExceptions.mjs.map
